module.exports = __webpack_public_path__ + "img/sunset-donk.b430ab27.jpg";